import axios from "axios";

function getTongDoanhTrongKhoang(ngayBD,ngayKT,linhVuc,idDV){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/dashboard/default/tongdoanhthu?ngayBD="+ngayBD+"&ngayKT="+ngayKT+"&linhVuc="+linhVuc+"&idDV="+idDV);
};
function getChiTietDoanhThu(ngayBD,ngayKT,ngayBDKyTruoc,ngayKTKyTruoc){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/dashboard/default/chitietdoanhthu?ngayBD="+ngayBD+"&ngayKT="+ngayKT+"&ngayBDKyTruoc="+ngayBDKyTruoc+"&ngayKTKyTruoc="+ngayKTKyTruoc);
};
function getChiTietHetHan(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/dashboard/default/chitiethethan");
};
function getDoanhSoDiaBan(ngayBD,ngayKT){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/dashboard/default/doanhsodiaban?ngayBD="+ngayBD+"&ngayKT="+ngayKT);
};
const DashBoardDefaultService={
  getTongDoanhTrongKhoang,
  getDoanhSoDiaBan,
  getChiTietDoanhThu,
  getChiTietHetHan
};
export default DashBoardDefaultService;
